<template>
  <div class="modal" :class="width" v-show="opened">
    <div class="modal-content">
      <div class="modal-body">
        <slot></slot>
      </div>
      <div class="modal-bottom d-flex justify-content-between border-top">
        <button type="button" class="btn btn-outline-dark px-4 py-2" @click="$emit('fechar')">Fechar</button>
        <slot name="acoes">
          <button class="btn btn-success px-4 py-2" @click="salvar()" v-if="!preview">Salvar</button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Modal",
    props: ['opened', 'width', 'preview'],
    methods: {
      salvar() {
        this.$emit('salvar', () => {
          this.$emit('atualizar');
        });
      }
    },

    created() {
      this.$parent.$on('openModal', (dados) => {
        this.$emit('loadDadosModal', dados)
      });
    }
  }
</script>

<style scoped>
  .modal {
    display: block; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 9990; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  }

  /* Modal Content/Box */
  .modal-content {
    background-color: #fefefe;
    margin: 30px auto 40px;
    border-radius: 4px;
    width: 450px;
    position: relative;
    height: calc(100vh - 70px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .modal.full .modal-content {
    position: relative;
    width: calc(100% - 100px);
    height: calc(100% - 32px);
    margin: 16px 16px 16px auto;
  }

  .modal-body {
    padding: 16px 15px;
    overflow: auto;
    flex: 1 1 auto;
    min-height: 0;
  }

  .modal-bottom {
    background-color: #FFFFFF;
    width: 100%;
    padding: 16px 15px;
    border-radius: 0 0 4px 4px;
    border: 1px solid;
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
    flex: 0 0 auto;
  }

  .modal.full .modal-bottom {
    width: 100%;
  }

  .modal.tiny .modal-content {
    background-color: #fefefe;
    margin: 35px auto 0;
    border-radius: 4px;
    max-width: 325px;
    height: auto;
  }

  .modal.tiny .modal-body {
    padding: 20px 10px 16px;
    overflow: visible;
  }

  @media (max-width: 767px) {
    .modal-content {
      margin: 10px auto;
      width: 95%!important;
      max-width: none;
      height: calc(100vh - 20px);
    }
  }
</style>
